import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgForfeitJobUrl from '@/assets/misc/img_forfeit-job.svg'
import JobNoLongerAvailableIllustration from '@/components/SpotIllustration/JobNoLongerAvailableIllustration'

export interface ForfeitDialogProps {
  showing: boolean
  onClose: () => unknown
  onForfeit: () => unknown
  isForfeitPending: boolean
  corporateMode: boolean
}

export function ForfeitDialog({
  showing,
  onClose,
  onForfeit,
  isForfeitPending,
  corporateMode,
}: ForfeitDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isForfeitPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgForfeitJobUrl}
              illustration={byDesign(
                undefined,
                JobNoLongerAvailableIllustration,
              )}
              alt="Man crumbling a piece of paper and throwing it away"
            />
          )}
          <ModalSheetContentTitle>
            Are you sure you want to forfeit this job?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Release this job and transfer it back to a pool of appropriate
            professionals.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            onPress={onClose}
            isDisabled={isForfeitPending}
          />
          <Button
            label="Forfeit Job"
            type="submit"
            isPending={isForfeitPending}
            isDisabled={isForfeitPending}
            onPress={onForfeit}
            variant="destructive"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
